export enum Roles {
    USER = "user",
    ADMIN = "admin",
    ROOT = "root",
    SUPER_ROOT_3000 = "superroot3000",
}
